import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const updateAudit = api(async function updateAudit({
    auditId,
    type,
    referenceId,
    shortDescription,
    longDescription,
    payload,
}) {
    return mutate(
        gql`
            mutation updateAudit(
                $auditId: String
                $type: String!
                $referenceId: String!
                $shortDescription: String
                $longDescription: String
                $payload: JSONObject
            ) {
                updateAudit(
                    auditId: $auditId
                    type: $type
                    referenceId: $referenceId
                    shortDescription: $shortDescription
                    longDescription: $longDescription
                    payload: $payload
                )
            }
        `,
        { auditId, type, referenceId, shortDescription, longDescription, payload },
        { returns: "updateAudit" }
    )
})
